import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { SelectPlayersToPay } from "../selectPlayersToPay/SelectPlayersToPay";

type props = {};

export const PayForPlayers: React.FC<props> = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}>
      <TCText
        style={{ fontWeight: 600, color: Colors.green, fontSize: 16 }}
        value="Players Summary"
      />
      <div
        style={{
          border: `1px solid ${Colors.green}`,
          paddingTop: 24,
          paddingBottom: 24,
          paddingLeft: 20,
          paddingRight: 20,
          borderRadius: 20,
          marginTop: 15,
          width: "100%",
        }}>
        <SelectPlayersToPay />
      </div>
    </div>
  );
};
